module.exports = __webpack_public_path__ + "img/rokka.eae09c2.png";